<template>
    <div class="transfer-default">
        <div class="row">
            <div class="col-12 text-start">
                <page-title
                  :title="'Administratie'"
                  icon="transfer"
                />
            </div>
        </div>

        <nav>
            <ul class="nav nav-underline">
                <li v-if="isAuthorized('administration', 'transfer-notes', 'view')" class="nav-item">
                    <router-link
                        class="nav-link"
                        :to="'/transfer/messages'"
                        active="true"
                        exact-active-class="active"
                    >
                       Berichten
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="isAuthorized('administration', 'news', 'view')"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/news'"
                        exact-active-class="active"
                    >
                        Nieuws
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="this.isGastouderapp()
                    && (
                      isAuthorized('gastouder', 'qualifications', 'view') ||
                      isAuthorized('gastouder', 'documents', 'view') ||
                      isAuthorized('gastouder', 'payout-details', 'view') ||
                      isAuthorized('gastouder', 'agreements', 'view') ||
                      isAuthorized('gastouder', 'correspondence', 'view') ||
                      isAuthorized('gastouder', 'benefit-overview', 'view') ||
                      isAuthorized('gastouder', 'annual-statement', 'view')
                    )"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/filesPersonal'"
                        exact-active-class="active"
                    >
                        Persoonlijke documenten
                    </router-link>
                </li>
                <li
                  v-if="isAuthorized('administration', 'general-documents', 'view')"
                    class="nav-item"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/filesGeneral'"
                        exact-active-class="active"
                    >
                        Algemene documenten
                    </router-link>
                </li>
                <li
                    v-if="isAuthorized('administration', 'person-register', 'view')"
                    class="nav-item"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/personRegister'"
                        exact-active-class="active"
                    >
                        Structureel aanwezigen
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="!this.isGastouderapp() && (
                        (this.getApplicationSetting('kdv_personeel') === '1' && isAuthorized('administration', 'employee-planning', 'view'))
                        || isAuthorized('administration', 'child-planning-mutations', 'view')
                    )"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/reports'"
                        exact-active-class="active"
                    >
                        Rapportages
                    </router-link>
                </li>
                <li
                    class="nav-item"
                    v-if="!this.isGastouderapp() && isAuthorized('administration', 'daycareRequest', 'view')"
                >
                    <router-link
                        class="nav-link"
                        :to="'/transfer/mutationRequests'"
                        exact-active-class="active"
                    >
                        Ouderapp aanvragen
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="py-3">
            <router-view/>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'

export default {
    name: 'transferDefault',
    components: {
        PageTitle,
    }
}
</script>

<style scoped>

.nav-underline {
    gap: 1.5rem;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    color: rgba(0,0,0,.5);
    border-bottom: .125rem solid transparent;
}
.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
    color: rgba(0,0,0,.7);
    border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
    font-weight: 600;
    color: rgba(0,0,0,.9);
    border-bottom-color: #2479bc;
}

@media only screen and (max-width: 767px) {
    .nav-underline {
        display: block;
        border-bottom: none;
    }
    .nav-underline .nav-item:not(:last-child) {
        margin-bottom: .5rem;
    }
    .nav-underline .nav-link {
        padding: .375rem .75rem;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: .25rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .nav-underline .nav-link.active,
    .nav-underline .show > .nav-link {
        border: 1px solid rgba(0,0,0,.5);
    }
}
</style>
